import intl from 'react-intl-universal';
import { inject, observer } from 'mobx-react';
import { useEffect, useState } from 'react';

import BottomTab from './BottomTab';
import { IBottomTab } from './BottomTab';
import PosterPortal from './PosterPortal';
import JigsawBottom from './JigsawBottom';
import { direct } from '../../utils/image';
import jigsawApi from '../../actions/jigsaw';
import RootStore from '../../store/RootStore';
import { IOneGallery } from "../GalleryList/Common";
import { minNumberByType, maxNumberByType } from './jigsaw-limits';
import activeGalleryInstance from '../GalleryList/ActiveGalleryInstance';

interface AllForBottom extends IBottomTab {
  rootStore?: RootStore;
  navigatorShow: boolean;
}

const AllForBottom = function(props: AllForBottom) {
  const { navigatorShow, component} = props;
  const { uiStore } = props.rootStore!;
  const activeGallery = activeGalleryInstance.get();
  const jigsaw = activeGallery ? activeGallery.jigsaw : { bottomShow: false, jigsawList: [] as IOneGallery[], type: '', from: '' };
  const setJigsaw = activeGallery ? activeGallery.setJigsaw : (() => {});
  const { bottomShow, jigsawList } = jigsaw;

  const [jigsawUrl, setJigsawUrl] = useState("");
  const [poster, setPoster] = useState([] as IOneGallery[]);

  const processEvent = (event: any) => {
    let { data } = event;
    // 必须实时读取，避免 useEffect([]) 闭包捕获到空 setJigsaw
    const gallery = activeGalleryInstance.get();
    if (!gallery) return;
    gallery.setJigsaw({
      type: "poster",
      bottomShow: true,
      jigsawList: data.ids,
      from: data.from || "",
    });
    setPoster(data.ids);
  };

  useEffect(() => {
    window.addEventListener("set-jigsaw-data", processEvent);

    return () => {
      window.removeEventListener("set-jigsaw-data", processEvent);
    };
  }, []);

  // console.log(bottomShow, 'bottomShow');
  const onCancel = () => {
    // 清空
    if (jigsaw && jigsaw.from && jigsaw.from == "bigpic") {
      let changeEvent = new Event("CHANGE_BODY_SCROLL");
      changeEvent.data = false;
      window.dispatchEvent(changeEvent);
    }
    setJigsaw({ bottomShow: false, jigsawList: [] });
  };

  const onConfirm = () => {
    const { length } = jigsawList;
    const { type } = jigsaw;
    if (length < minNumberByType(type)) {
      const minKey = type === "download" ? "min-download" : "min-jigsaw";
      uiStore.showAlert({
        content: intl.get(minKey, { num: minNumberByType(jigsaw.type) }),
      });
      return;
    } else if (length > maxNumberByType(type)) {
      const maxKey =
        type === "download" ? "MAX_DOWNLOAD_NUM" : "MAX_JIGSAW_NUM";
      uiStore.showAlert({
        content: intl.get(maxKey, {
          num: maxNumberByType(jigsaw.type),
        }),
      });
      return;
    }

    if (type == "long") {
      uiStore.showToast({
        icon: "loading",
        content: intl.get("Collaging"),
        time: 20000,
      });
      /* 原来的接口调用*/
      jigsawApi
        .create({
          galleryid: window.gallery.id,
          imageids: JSON.stringify(jigsawList.map((it) => it.id)),
        })
        .then((jsonData) => {
          uiStore.hideToast();
          const { data } = jsonData;
          if (data) {
            setJigsawUrl(direct(data));
          }
        })
        .catch((e) => {
          uiStore.hideToast();
          throw e;
        });
    }
    if (jigsaw.type == "poster") {
      setPoster(jigsawList);
    }
    if (jigsaw.type == "download") {
      // 直接调起小程序下载了，代码层无需处理
    }
    if (jigsaw.type == "share") {
      // 根据选择的ids生成分享链接
      console.log(`share`);
    }

    // onCancel();
  };

  if (bottomShow) {
    return (
      <>
        <JigsawBottom
          onCancel={onCancel}
          onConfirm={onConfirm}
          type={jigsaw.type}
          list={jigsawList}
        />
        {/*<JigsawPortal
          url={jigsawUrl}
          onClose={() => {
            setJigsawUrl("");
            onCancel();
          }}
        />*/}
        {
          // 注意，PosterPortal里边会锁定滚动，所以不适合在不需要的场景下渲染出来
          poster?.length && (
            <PosterPortal
              data={poster}
              onClose={() => {
                setPoster([]);
                onCancel();
              }}
            />
          )
        }
      </>
    );
  }


  return navigatorShow ? <BottomTab {...props} component={component} /> : null;
};

export default inject("rootStore")(observer(AllForBottom));
